'use client';

import { BookBase } from '@doist/icons/brand';
import { Box, Button, Container, Heading, Stack } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { useLocale } from 'next-intl';
import { AdvancedTable } from './pricing-tables/advanced-table';
import { CollaborationTable } from './pricing-tables/collaboration-table';
import { EssentialsTable } from './pricing-tables/essentials-table';
import { PlanNames } from './pricing-tables/plan-names';
import { TaskViewsTable } from './pricing-tables/task-views-table';
import css from './comparison-table.module.css';
export function ComparisonTable() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'pricing_v2_3');
  return <Container width="lg" className="mbs-64 lg-mbs-128" data-sentry-element="Container" data-sentry-component="ComparisonTable" data-sentry-source-file="comparison-table.tsx">
            <Box className={css.comparisonTable} data-sentry-element="Box" data-sentry-source-file="comparison-table.tsx">
                <Box className={css.header} data-sentry-element="Box" data-sentry-source-file="comparison-table.tsx">
                    <Heading level="2" size="major-base" id="compare" data-sentry-element="Heading" data-sentry-source-file="comparison-table.tsx">
                        {t('comparison.title')}
                    </Heading>
                    <Button href="/help/articles/teams-faq-lQhBHo0y6" variant="tertiary" startIcon={BookBase} bleed="inline" data-sentry-element="Button" data-sentry-source-file="comparison-table.tsx">
                        {t('ctaSection.readTheFaq')}
                    </Button>
                </Box>
                <Box className={css.inner} data-sentry-element="Box" data-sentry-source-file="comparison-table.tsx">
                    <PlanNames data-sentry-element="PlanNames" data-sentry-source-file="comparison-table.tsx" />
                    <Stack gap={{
          xs: '32',
          md: '64'
        }} data-sentry-element="Stack" data-sentry-source-file="comparison-table.tsx">
                        <EssentialsTable data-sentry-element="EssentialsTable" data-sentry-source-file="comparison-table.tsx" />
                        <TaskViewsTable data-sentry-element="TaskViewsTable" data-sentry-source-file="comparison-table.tsx" />
                        <CollaborationTable data-sentry-element="CollaborationTable" data-sentry-source-file="comparison-table.tsx" />
                        <AdvancedTable data-sentry-element="AdvancedTable" data-sentry-source-file="comparison-table.tsx" />
                    </Stack>
                </Box>
            </Box>
        </Container>;
}